/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { useIntl } from 'react-intl';

const NavItem = (props: any) => {
    const { lang, handleClick, loading } = props;
    const intl = useIntl();

    const handleclick = () => {
        handleClick();
    }

    return (
        <div className='menu-item'>
            <a
                className='menu-link'
                onClick={handleclick}
            >
                {!loading &&
                    <>
                        <div style={{ width: '4px', height: '4px', borderRadius: '100%', background: '#b5b5c3', marginRight: '10px', marginLeft: '9px' }}></div>
                        <span className='menu-title'>{intl.formatMessage({ id: lang })}</span>
                    </>
                }
                {loading && (
                    <>
                        <div style={{ width: '4px', height: '4px', borderRadius: '100%', background: '#b5b5c3', marginRight: '10px', marginLeft: '9px' }}></div>
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    </>
                )}
            </a>
        </div>
    )
}

export default NavItem;